module.exports = __webpack_public_path__ + "static/media/filled_bar_postlapAERO_hand.85e1132f.svg";